<template>
  <div class="news-container">
    <div class="title">{{columnName}}</div>
    <div class="inner-container">
      <div class="news-title" v-html="article.title"></div>
      <div class="news-desc">
        <span v-if="isExistSourceOrg">文章来源： <strong class="author">{{article.source_org}}</strong></span>
        <span class="time">发布时间：{{article.check_time_format}}</span>
        <span v-if="isExistTextAuthor">文作者：{{article.text_author}}</span>
        <span v-if="isExistImgAuthor">图作者：{{article.img_author}}</span>
      </div>
      <div class="news-text">
        <div v-html="article.text"></div>
        <video-player v-if="this.playerOptions.sources[0].src !== '' && this.playerOptions.sources[0].src !== null" :options="playerOptions"></video-player>
      </div>

      <div :class="(nextArticle === null && inPrevious === null) ? '' : 'latest'">
        <p class="prev" v-if="nextArticle !== null" @click="toDetail(nextArticle.id)">上一篇：<span>{{nextArticle.title}}</span></p>
        <p class="next" v-if="inPrevious !== null" @click="toDetail(inPrevious.id)">下一篇：<span>{{inPrevious.title}}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { requestUrl } from '../common/constant'
import { mapMutations, mapGetters } from 'vuex'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

export default {
  name: 'Content',
  computed: {
    ...mapGetters({
      articleId: 'getArticleId'
    })
  },
  components: {
    videoPlayer
  },
  watch: {
    articleId: function (articleId) {
      this.id = articleId
      this.init()
    }
  },
  data () {
    return {
      columnName: '',
      id: '',
      isExistSourceOrg: true,
      isExistTextAuthor: true,
      isExistImgAuthor: true,
      article: {},
      nextArticle: {},
      inPrevious: {},
      navList: {},
      playerOptions: {
        // videojs options
        muted: false,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: ''
        }],
        poster: '/static/images/author.jpg'
      }
    }
  },
  async created () {
    this.id = this.$route.params.id
    await this.init()
  },
  methods: {
    ...mapMutations([
      'updateArticleId'
    ]),
    async init () {
      await this.getArticle()
      await this.getColumnName()
    },
    async getArticle () {
      const article = await axios.get(`${requestUrl}/news/getArticle/${this.id}`)
      this.article = article.data.article
      const checkTime = this.article.check_time_format.substring(0, 11)
      this.article.check_time_format = checkTime
      this.playerOptions.sources[0].src = this.article.video_url
      if (this.article.source_org === null || this.article.source_org.trim() === '') {
        this.isExistSourceOrg = false
      }
      if (this.article.text_author === null || this.article.text_author.trim() === '') {
        this.isExistTextAuthor = false
      }
      if (this.article.img_author === null || this.article.img_author.trim() === '') {
        this.isExistImgAuthor = false
      }
      this.nextArticle = article.data.next_article
      this.inPrevious = article.data.in_previous
    },
    async getColumnName () {
      const columns = await axios.get(`${requestUrl}/news/getArticleMenu/${this.id}`)
      this.columnName = columns.data.article.article.column_name
    },
    toDetail (id) {
      this.updateArticleId(id)
    }
  }
}
</script>

<style scoped>
.news-container {
  width: 940px;
  box-sizing: border-box;
  padding: 30px;
  border: 1px solid #cccccc;
}

.title {
  font-size: 24px;
  color: #333333;
  font-weight: 700;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 14px;
}

.inner-container {
  margin-top: 20px;
}

.news-title {
  font-size: 24px;
  font-weight: 350;
  line-height: 33px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.news-desc {
  width: 100%;
  padding: 12px 0;
  border-top: 1px solid #e3e4e5;
  border-bottom: 1px solid #e3e4e5;
  color: #888888;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  margin-top: 16px;
}

.news-desc > span {
  color: #888888;
  font-size: 14px;
  margin-left: 14px;
}

.author {
  font-weight: 700;
  color: #333333;
}

.time {
  color: #888888;
}

.news-text >>> p{
  line-height: 26px;
  text-align: left;
  text-indent: 2em;
}

.news-text >>> img {
  display: block;
  margin: 0 auto;
}

.news-text >>> p, span {
  color: #333333;
  line-height: 1.5;
}

.latest {
  margin-top: 80px;
  border-top: 2px solid #cccccc;
  color: #888888;
}

.latest span {
  color: #888888;
}

.latest span:hover {
  color: rgb(38,66,158);
  cursor: pointer;
}

.latest .prev {
  margin-top: 4px;
}

.latest .next {
  margin-top: 6px;
}

.news-text >>> .video-js {
  width: 100% !important;
}

.news-text >>> .vjs-big-play-button {
  width: 78px;
  height: 78px;
  line-height: 76px;
  border-radius: 50px;
  font-size: 50px;
  border: none;
  top: 50%;
  left: 45%;
  transform: translateX(-50%);
  transform: translateY(-50%);
}
</style>
